import { createSystem, defaultConfig } from '@chakra-ui/react';

import foundationConfigs from './foundations';

const system = createSystem(defaultConfig, ...foundationConfigs);
export default system;
